export class AssetAttributes {
  lightThemeColor: string;
  darkThemeColor: string;
}
